import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { TermsAcceptanceGate } from "@/components/TermsAcceptanceGate"
import { useAuth } from "@/contexts/AuthContext"

type ProtectedRouteProps = {
  children: ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <TermsAcceptanceGate>{children}</TermsAcceptanceGate>
}
